import type { Contract } from './types';

import { ENDPOINT } from '~/constants';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodContractSchema } from './validations';

/**
 * Fetches a single contract's header by ID from the API, without its line
 * items: a contract can hold tens of thousands of them, so they are only ever
 * read through the paginated items endpoint.
 *
 * @param contractId - The UUID of the contract to fetch.
 * @param options - Additional request options.
 * @returns The contract data.
 * @throws Error if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/get_contract_contracts__contract_id__get
 */
export const fetchContract = async (
  contractId: UUID,
  options?: KyRequestOptions,
) => {
  return vestigasApi
    .get(ENDPOINT.CONTRACT.GET(contractId), {
      ...options,
      // Set after the options so no caller can switch the items back on.
      searchParams: { returnItems: false },
      validate: {
        ...options?.validate,
        response: zodContractSchema,
      },
    })
    .json<Contract>();
};
